export default __webpack_public_path__ + "static/media/close.2aeb1b38.jfif";